import { createSelector } from 'reselect';
import { QUESTIONNAIRE_PAGE_URL } from 'src/constants/constants';
import urlParamsMapper from 'src/helpers/urlParamsMapper.js';

// selector
const getNewDashboard = state => state.newDashboard;
// reselect function
export const getNewDashboardState = createSelector([getNewDashboard], newDashboard => newDashboard);

const questionnaireInitState = state => state.caseDatacollectMenu;
export const getQuestionnaireState = createSelector([questionnaireInitState], caseDatacollectMenu => caseDatacollectMenu);

export const deriveMenuAndIndex = (pageId, isCompletePage = false) =>
  createSelector([getQuestionnaireState], data => {
    const { intro, page } = data;

    let menuSource = null;
    let menuIndex = 0;

    if (page && page.menus) {
      menuSource = page;
    } else if (intro && intro.menus) {
      menuSource = intro;
    } else {
      return data.menu;
    }

    const languageId = 1;

    let newMenu = [];
    const { menus } = menuSource;
    let menuItemIndex = 0;
    let menuItem;
    const numOfMenus = menus.length;

    function updateNewMenu(subItem, subIndex) {
      /*
       * Dynamic menus have their true pieces of content nested inside subMenus
       */
      if (subItem.subMenu.length) {
        return subItem.subMenu.forEach(updateNewMenu);
      }

      const { subMenu, ...menuData } = subItem;
      const subMenuUrl = urlParamsMapper(QUESTIONNAIRE_PAGE_URL, {
        ...menuSource,
        languageId,
        pageId: menuData.pageId,
        sectionName: menuItem.menuName,
      });

      if (pageId === menuData.pageId) {
        menuIndex = newMenu.length;
      }

      newMenu.push({ ...menuData, url: subMenuUrl });
    }

    for (menuItemIndex; menuItemIndex < numOfMenus; menuItemIndex += 1) {
      menuItem = menus[menuItemIndex];

      if (menuItem && menuItem.subMenu) {
        menuItem.subMenu.forEach(updateNewMenu);
      }
    }

    if (isCompletePage) {
      menuIndex++;
    }

    return { menu: newMenu, index: menuIndex };
  });
